import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { ConfigurationRestWebPage } from '../../../configuration/configuration-rest-web/configuration-rest-web';
import { HomePage } from '../../../home/home';

@Component({
  selector: 'page-tutorial-pedidos',
  templateUrl: 'tutorial-pedidos.html',
})
export class TutorialPedidosPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public dishServices: DishServices) {

  }

  close() {
    if (this.globals.checkLimitsByLicense('sites', 'sites')) {
      this.globals.side_menu_active = 'web';
      this.navCtrl.setRoot(ConfigurationRestWebPage);
      this.globals.side_menu_active_analytics = false;
    } else {
      this.navCtrl.push(HomePage);
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/help/tutorials/tutorial-pedidos/tutorial-pedidos.ts